const categoryCode = {
  "code": 0,
  "message": "정상적으로 호출하였습니다.",
  "data": {
    "firstBusinessType": [
      {
        "parentCode": "",
        "code": "001",
        "name": "건강"
      },
      {
        "parentCode": "",
        "code": "002",
        "name": "교육"
      },
      {
        "parentCode": "",
        "code": "003",
        "name": "교통/운송서비스"
      },
      {
        "parentCode": "",
        "code": "004",
        "name": "금융"
      },
      {
        "parentCode": "",
        "code": "005",
        "name": "미용"
      },
      {
        "parentCode": "",
        "code": "006",
        "name": "소매(쇼핑몰)"
      },
      {
        "parentCode": "",
        "code": "007",
        "name": "엔터테인먼트"
      },
      {
        "parentCode": "",
        "code": "008",
        "name": "여가"
      },
      {
        "parentCode": "",
        "code": "009",
        "name": "게임"
      },
      {
        "parentCode": "",
        "code": "010",
        "name": "출산/육아"
      },
      {
        "parentCode": "",
        "code": "011",
        "name": "음식점"
      },
      {
        "parentCode": "",
        "code": "012",
        "name": "자동차"
      },
      {
        "parentCode": "",
        "code": "013",
        "name": "컴퓨터"
      },
      {
        "parentCode": "",
        "code": "014",
        "name": "산업"
      },
      {
        "parentCode": "",
        "code": "015",
        "name": "기관/단체"
      },
      {
        "parentCode": "",
        "code": "016",
        "name": "광고"
      },
      {
        "parentCode": "",
        "code": "017",
        "name": "방송사/출판"
      },
      {
        "parentCode": "",
        "code": "018",
        "name": "인터넷/통신"
      },
      {
        "parentCode": "",
        "code": "019",
        "name": "일반서비스"
      },
      {
        "parentCode": "",
        "code": "020",
        "name": "전문서비스"
      },
      {
        "parentCode": "",
        "code": "021",
        "name": "기타서비스"
      }
    ],
    "secondBusinessType": [
      {
        "parentCode": "001",
        "code": "0010001",
        "name": "병원"
      },
      {
        "parentCode": "001",
        "code": "0010002",
        "name": "약국"
      },
      {
        "parentCode": "001",
        "code": "0010003",
        "name": "의료기기/의약품"
      },
      {
        "parentCode": "001",
        "code": "0010004",
        "name": "건강식품/건강정보"
      },
      {
        "parentCode": "001",
        "code": "0010005",
        "name": "심리치료/명상/기타대체의학"
      },
      {
        "parentCode": "002",
        "code": "0020001",
        "name": "학교"
      },
      {
        "parentCode": "002",
        "code": "0020002",
        "name": "학원"
      },
      {
        "parentCode": "002",
        "code": "0020003",
        "name": "교육원"
      },
      {
        "parentCode": "002",
        "code": "0020004",
        "name": "학습지"
      },
      {
        "parentCode": "002",
        "code": "0020005",
        "name": "교육정보/접수대행/자격증"
      },
      {
        "parentCode": "002",
        "code": "0020006",
        "name": "기타교육서비스"
      },
      {
        "parentCode": "003",
        "code": "0030001",
        "name": "운송서비스"
      },
      {
        "parentCode": "003",
        "code": "0030002",
        "name": "항공/철도"
      },
      {
        "parentCode": "003",
        "code": "0030003",
        "name": "택시/대리운전"
      },
      {
        "parentCode": "003",
        "code": "0030004",
        "name": "기타교통/운송서비스"
      },
      {
        "parentCode": "004",
        "code": "0040001",
        "name": "은행"
      },
      {
        "parentCode": "004",
        "code": "0040002",
        "name": "신용"
      },
      {
        "parentCode": "004",
        "code": "0040003",
        "name": "보험"
      },
      {
        "parentCode": "004",
        "code": "0040004",
        "name": "대출"
      },
      {
        "parentCode": "004",
        "code": "0040005",
        "name": "재테크"
      },
      {
        "parentCode": "004",
        "code": "0040006",
        "name": "부동산"
      },
      {
        "parentCode": "004",
        "code": "0040007",
        "name": "기타금융서비스"
      },
      {
        "parentCode": "005",
        "code": "0050001",
        "name": "미용"
      },
      {
        "parentCode": "006",
        "code": "0060001",
        "name": "가구/인테리어"
      },
      {
        "parentCode": "006",
        "code": "0060002",
        "name": "전자"
      },
      {
        "parentCode": "006",
        "code": "0060003",
        "name": "생활/주방/문구"
      },
      {
        "parentCode": "006",
        "code": "0060004",
        "name": "식품"
      },
      {
        "parentCode": "006",
        "code": "0060005",
        "name": "의류"
      },
      {
        "parentCode": "006",
        "code": "0060006",
        "name": "패션잡화"
      },
      {
        "parentCode": "006",
        "code": "0060007",
        "name": "꽃배달/선물"
      },
      {
        "parentCode": "006",
        "code": "0060008",
        "name": "취미"
      },
      {
        "parentCode": "006",
        "code": "0060009",
        "name": "종합쇼핑몰/백화점"
      },
      {
        "parentCode": "006",
        "code": "0060010",
        "name": "홈쇼핑"
      },
      {
        "parentCode": "006",
        "code": "0060011",
        "name": "소셜커머스"
      },
      {
        "parentCode": "006",
        "code": "0060012",
        "name": "네트워크마케팅쇼핑몰"
      },
      {
        "parentCode": "006",
        "code": "0060013",
        "name": "구매대행"
      },
      {
        "parentCode": "006",
        "code": "0060014",
        "name": "기타소매"
      },
      {
        "parentCode": "007",
        "code": "0070001",
        "name": "공연/전시"
      },
      {
        "parentCode": "007",
        "code": "0070002",
        "name": "티켓예매"
      },
      {
        "parentCode": "007",
        "code": "0070003",
        "name": "영화"
      },
      {
        "parentCode": "007",
        "code": "0070004",
        "name": "도서/만화"
      },
      {
        "parentCode": "007",
        "code": "0070005",
        "name": "복권"
      },
      {
        "parentCode": "007",
        "code": "0070006",
        "name": "다운로드서비스"
      },
      {
        "parentCode": "007",
        "code": "0070007",
        "name": "스트리밍서비스"
      },
      {
        "parentCode": "007",
        "code": "0070008",
        "name": "운세서비스"
      },
      {
        "parentCode": "007",
        "code": "0070009",
        "name": "제작서비스"
      },
      {
        "parentCode": "007",
        "code": "0070010",
        "name": "이벤트"
      },
      {
        "parentCode": "007",
        "code": "0070011",
        "name": "기획사"
      },
      {
        "parentCode": "007",
        "code": "0070012",
        "name": "기타엔터테인먼트"
      },
      {
        "parentCode": "008",
        "code": "0080001",
        "name": "국내숙박"
      },
      {
        "parentCode": "008",
        "code": "0080002",
        "name": "국내여행"
      },
      {
        "parentCode": "008",
        "code": "0080003",
        "name": "해외숙박"
      },
      {
        "parentCode": "008",
        "code": "0080004",
        "name": "해외여행"
      },
      {
        "parentCode": "008",
        "code": "0080005",
        "name": "종합여행사/여행정보"
      },
      {
        "parentCode": "008",
        "code": "0080006",
        "name": "항공권"
      },
      {
        "parentCode": "008",
        "code": "0080007",
        "name": "여권/비자"
      },
      {
        "parentCode": "008",
        "code": "0080008",
        "name": "스포츠/레포츠"
      },
      {
        "parentCode": "008",
        "code": "0080009",
        "name": "스포츠/레포츠용품"
      },
      {
        "parentCode": "008",
        "code": "0080010",
        "name": "기타여가서비스"
      },
      {
        "parentCode": "009",
        "code": "0090001",
        "name": "모바일게임"
      },
      {
        "parentCode": "009",
        "code": "0090002",
        "name": "PC게임"
      },
      {
        "parentCode": "010",
        "code": "0100001",
        "name": "육아"
      },
      {
        "parentCode": "010",
        "code": "0100002",
        "name": "출산"
      },
      {
        "parentCode": "011",
        "code": "0110001",
        "name": "음식점"
      },
      {
        "parentCode": "011",
        "code": "0110002",
        "name": "제과/제빵"
      },
      {
        "parentCode": "011",
        "code": "0110003",
        "name": "유흥"
      },
      {
        "parentCode": "011",
        "code": "0110004",
        "name": "카페"
      },
      {
        "parentCode": "011",
        "code": "0110005",
        "name": "프랜차이즈"
      },
      {
        "parentCode": "012",
        "code": "0120001",
        "name": "렌트/차량공유"
      },
      {
        "parentCode": "012",
        "code": "0120002",
        "name": "신차판매"
      },
      {
        "parentCode": "012",
        "code": "0120003",
        "name": "자동차관리"
      },
      {
        "parentCode": "012",
        "code": "0120004",
        "name": "자동차용품"
      },
      {
        "parentCode": "012",
        "code": "0120005",
        "name": "주차장"
      },
      {
        "parentCode": "012",
        "code": "0120006",
        "name": "중고차"
      },
      {
        "parentCode": "012",
        "code": "0120007",
        "name": "폐차장"
      },
      {
        "parentCode": "013",
        "code": "0130001",
        "name": "소프트웨어/솔루션"
      },
      {
        "parentCode": "013",
        "code": "0130002",
        "name": "컴퓨터수리/보수"
      },
      {
        "parentCode": "014",
        "code": "0140001",
        "name": "공구/산업용품"
      },
      {
        "parentCode": "015",
        "code": "0150001",
        "name": "공공기관"
      },
      {
        "parentCode": "015",
        "code": "0150002",
        "name": "일반단체"
      },
      {
        "parentCode": "015",
        "code": "0150003",
        "name": "주거시설"
      },
      {
        "parentCode": "015",
        "code": "0150004",
        "name": "정치"
      },
      {
        "parentCode": "015",
        "code": "0150005",
        "name": "종교"
      },
      {
        "parentCode": "016",
        "code": "0160001",
        "name": "광고물"
      },
      {
        "parentCode": "017",
        "code": "0170001",
        "name": "방송/신문"
      },
      {
        "parentCode": "017",
        "code": "0170002",
        "name": "출판"
      },
      {
        "parentCode": "018",
        "code": "0180001",
        "name": "웹서비스"
      },
      {
        "parentCode": "018",
        "code": "0180002",
        "name": "전용선/방송"
      },
      {
        "parentCode": "018",
        "code": "0180003",
        "name": "통신서비스"
      },
      {
        "parentCode": "018",
        "code": "0180004",
        "name": "포털서비스"
      },
      {
        "parentCode": "019",
        "code": "0190001",
        "name": "결혼/소개팅"
      },
      {
        "parentCode": "019",
        "code": "0190002",
        "name": "보안서비스"
      },
      {
        "parentCode": "019",
        "code": "0190003",
        "name": "생활서비스"
      },
      {
        "parentCode": "019",
        "code": "0190004",
        "name": "취업"
      },
      {
        "parentCode": "019",
        "code": "0190005",
        "name": "인력파견"
      },
      {
        "parentCode": "019",
        "code": "0190006",
        "name": "기타일반서비스"
      },
      {
        "parentCode": "020",
        "code": "0200001",
        "name": "건축"
      },
      {
        "parentCode": "020",
        "code": "0200002",
        "name": "법률서비스"
      },
      {
        "parentCode": "020",
        "code": "0200003",
        "name": "세무/회계/금융서비스"
      },
      {
        "parentCode": "020",
        "code": "0200004",
        "name": "통/번역"
      },
      {
        "parentCode": "020",
        "code": "0200005",
        "name": "기타전문서비스"
      },
      {
        "parentCode": "021",
        "code": "0210001",
        "name": "맴버십/포인트"
      },
      {
        "parentCode": "021",
        "code": "0210002",
        "name": "업무알림"
      }
    ],
    "thirdBusinessType": [
      {
        "parentCode": "0010001",
        "code": "00100010001",
        "name": "종합병원"
      },
      {
        "parentCode": "0010001",
        "code": "00100010002",
        "name": "피부과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010003",
        "name": "성형외과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010004",
        "name": "안과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010005",
        "name": "이비인후과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010006",
        "name": "정형외과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010007",
        "name": "치과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010008",
        "name": "비뇨기과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010009",
        "name": "대장항문과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010010",
        "name": "산부인과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010011",
        "name": "소아과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010012",
        "name": "내과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010013",
        "name": "외과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010014",
        "name": "신경정신과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010015",
        "name": "물리치료과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010016",
        "name": "재활의학과"
      },
      {
        "parentCode": "0010001",
        "code": "00100010017",
        "name": "한의원"
      },
      {
        "parentCode": "0010001",
        "code": "00100010018",
        "name": "정신병원"
      },
      {
        "parentCode": "0010001",
        "code": "00100010019",
        "name": "노인병원"
      },
      {
        "parentCode": "0010001",
        "code": "00100010020",
        "name": "요양병원"
      },
      {
        "parentCode": "0010001",
        "code": "00100010021",
        "name": "동물병원"
      },
      {
        "parentCode": "0010001",
        "code": "00100010022",
        "name": "기타병원"
      },
      {
        "parentCode": "0010002",
        "code": "00100020001",
        "name": "약국"
      },
      {
        "parentCode": "0010003",
        "code": "00100030001",
        "name": "의료기기/의약품"
      },
      {
        "parentCode": "0010004",
        "code": "00100040001",
        "name": "건강식품/건강정보"
      },
      {
        "parentCode": "0010005",
        "code": "00100050001",
        "name": "심리치료/명상/기타대체의학"
      },
      {
        "parentCode": "0020001",
        "code": "00200010001",
        "name": "유치원"
      },
      {
        "parentCode": "0020001",
        "code": "00200010002",
        "name": "초등학교"
      },
      {
        "parentCode": "0020001",
        "code": "00200010003",
        "name": "중학교"
      },
      {
        "parentCode": "0020001",
        "code": "00200010004",
        "name": "고등학교"
      },
      {
        "parentCode": "0020001",
        "code": "00200010005",
        "name": "대학"
      },
      {
        "parentCode": "0020001",
        "code": "00200010006",
        "name": "대학교"
      },
      {
        "parentCode": "0020001",
        "code": "00200010007",
        "name": "대학원"
      },
      {
        "parentCode": "0020001",
        "code": "00200010008",
        "name": "대안학교/작업학교"
      },
      {
        "parentCode": "0020002",
        "code": "00200020001",
        "name": "오프라인학원"
      },
      {
        "parentCode": "0020002",
        "code": "00200020002",
        "name": "온라인학원"
      },
      {
        "parentCode": "0020003",
        "code": "00200030001",
        "name": "어린이집/평생교육원/문화센터"
      },
      {
        "parentCode": "0020004",
        "code": "00200040001",
        "name": "학습지"
      },
      {
        "parentCode": "0020005",
        "code": "00200050001",
        "name": "교육정보/접수대행/자격증"
      },
      {
        "parentCode": "0020006",
        "code": "00200060001",
        "name": "기타교육서비스"
      },
      {
        "parentCode": "0030001",
        "code": "00300010001",
        "name": "이사"
      },
      {
        "parentCode": "0030001",
        "code": "00300010002",
        "name": "택배"
      },
      {
        "parentCode": "0030001",
        "code": "00300010003",
        "name": "물류/창고/컨테이너"
      },
      {
        "parentCode": "0030002",
        "code": "00300020001",
        "name": "항공/철도"
      },
      {
        "parentCode": "0030003",
        "code": "00300030001",
        "name": "대리운전"
      },
      {
        "parentCode": "0030003",
        "code": "00300030002",
        "name": "콜택시"
      },
      {
        "parentCode": "0030004",
        "code": "00300040001",
        "name": "기타교통/운송서비스"
      },
      {
        "parentCode": "0040001",
        "code": "00400010001",
        "name": "1금융권"
      },
      {
        "parentCode": "0040001",
        "code": "00400010002",
        "name": "2금융 은행권"
      },
      {
        "parentCode": "0040002",
        "code": "00400020001",
        "name": "신용카드"
      },
      {
        "parentCode": "0040002",
        "code": "00400020002",
        "name": "신용정보/신용조사/채권추심"
      },
      {
        "parentCode": "0040003",
        "code": "00400030001",
        "name": "보험"
      },
      {
        "parentCode": "0040004",
        "code": "00400040001",
        "name": "2금융 캐피탈"
      },
      {
        "parentCode": "0040004",
        "code": "00400040002",
        "name": "기타대출"
      },
      {
        "parentCode": "0040005",
        "code": "00400050001",
        "name": "투자/증권"
      },
      {
        "parentCode": "0040005",
        "code": "00400050002",
        "name": "가상화폐"
      },
      {
        "parentCode": "0040006",
        "code": "00400060001",
        "name": "부동산"
      },
      {
        "parentCode": "0040007",
        "code": "00400070001",
        "name": "기타금융서비스"
      },
      {
        "parentCode": "0050001",
        "code": "00500010001",
        "name": "헤어샵"
      },
      {
        "parentCode": "0050001",
        "code": "00500010002",
        "name": "뷰티케어샵/체형클리닉"
      },
      {
        "parentCode": "0050001",
        "code": "00500010003",
        "name": "미용용품/기기"
      },
      {
        "parentCode": "0050001",
        "code": "00500010004",
        "name": "뷰티/화장품"
      },
      {
        "parentCode": "0050001",
        "code": "00500010005",
        "name": "기타미용"
      },
      {
        "parentCode": "0060001",
        "code": "00600010001",
        "name": "가구/인테리어"
      },
      {
        "parentCode": "0060002",
        "code": "00600020001",
        "name": "전자"
      },
      {
        "parentCode": "0060003",
        "code": "00600030001",
        "name": "생활/주방/문구"
      },
      {
        "parentCode": "0060004",
        "code": "00600040001",
        "name": "식품"
      },
      {
        "parentCode": "0060005",
        "code": "00600050001",
        "name": "의류"
      },
      {
        "parentCode": "0060006",
        "code": "00600060001",
        "name": "패션잡화"
      },
      {
        "parentCode": "0060007",
        "code": "00600070001",
        "name": "꽃배달/선물"
      },
      {
        "parentCode": "0060008",
        "code": "00600080001",
        "name": "취미"
      },
      {
        "parentCode": "0060009",
        "code": "00600090001",
        "name": "종합쇼핑몰/백화점"
      },
      {
        "parentCode": "0060010",
        "code": "00600100001",
        "name": "홈쇼핑"
      },
      {
        "parentCode": "0060011",
        "code": "00600110001",
        "name": "소셜커머스"
      },
      {
        "parentCode": "0060012",
        "code": "00600120001",
        "name": "네트워크마케팅쇼핑몰"
      },
      {
        "parentCode": "0060013",
        "code": "00600130001",
        "name": "구매대행"
      },
      {
        "parentCode": "0060014",
        "code": "00600140001",
        "name": "기타소매"
      },
      {
        "parentCode": "0070001",
        "code": "00700010001",
        "name": "공연/전시"
      },
      {
        "parentCode": "0070002",
        "code": "00700020001",
        "name": "티켓예매"
      },
      {
        "parentCode": "0070003",
        "code": "00700030001",
        "name": "영화"
      },
      {
        "parentCode": "0070004",
        "code": "00700040001",
        "name": "도서/만화"
      },
      {
        "parentCode": "0070005",
        "code": "00700050001",
        "name": "복권"
      },
      {
        "parentCode": "0070006",
        "code": "00700060001",
        "name": "웹하드/p2p"
      },
      {
        "parentCode": "0070007",
        "code": "00700070001",
        "name": "음원/영상스트리밍"
      },
      {
        "parentCode": "0070008",
        "code": "00700080001",
        "name": "운세서비스"
      },
      {
        "parentCode": "0070009",
        "code": "00700090001",
        "name": "음원/영상제작"
      },
      {
        "parentCode": "0070010",
        "code": "00700100001",
        "name": "이벤트대행/용품"
      },
      {
        "parentCode": "0070011",
        "code": "00700110001",
        "name": "기획사"
      },
      {
        "parentCode": "0070012",
        "code": "00700120001",
        "name": "기타엔터테인먼트"
      },
      {
        "parentCode": "0080001",
        "code": "00800010001",
        "name": "국내숙박"
      },
      {
        "parentCode": "0080002",
        "code": "00800020001",
        "name": "국내여행"
      },
      {
        "parentCode": "0080003",
        "code": "00800030001",
        "name": "해외숙박"
      },
      {
        "parentCode": "0080004",
        "code": "00800040001",
        "name": "해외여행"
      },
      {
        "parentCode": "0080005",
        "code": "00800050001",
        "name": "종합여행사/여행정보"
      },
      {
        "parentCode": "0080006",
        "code": "00800060001",
        "name": "항공권"
      },
      {
        "parentCode": "0080007",
        "code": "00800070001",
        "name": "여권/비자"
      },
      {
        "parentCode": "0080008",
        "code": "00800080001",
        "name": "스포츠/레포츠"
      },
      {
        "parentCode": "0080009",
        "code": "00800090001",
        "name": "스포츠/레포츠용품"
      },
      {
        "parentCode": "0080010",
        "code": "00800100001",
        "name": "기타여가서비스"
      },
      {
        "parentCode": "0090001",
        "code": "00900010001",
        "name": "모바일게임"
      },
      {
        "parentCode": "0090002",
        "code": "00900020001",
        "name": "PC게임"
      },
      {
        "parentCode": "0100001",
        "code": "01000010001",
        "name": "돌/유아동용품/유아동복/육아정보"
      },
      {
        "parentCode": "0100002",
        "code": "01000020001",
        "name": "임부복/산후조리원/출산정보"
      },
      {
        "parentCode": "0110001",
        "code": "01100010001",
        "name": "음식점"
      },
      {
        "parentCode": "0110002",
        "code": "01100020001",
        "name": "제과/제빵"
      },
      {
        "parentCode": "0110003",
        "code": "01100030001",
        "name": "유흥"
      },
      {
        "parentCode": "0110004",
        "code": "01100040001",
        "name": "카페"
      },
      {
        "parentCode": "0110005",
        "code": "01100050001",
        "name": "프랜차이즈"
      },
      {
        "parentCode": "0120001",
        "code": "01200010001",
        "name": "렌트/차량공유"
      },
      {
        "parentCode": "0120002",
        "code": "01200020001",
        "name": "신차판매"
      },
      {
        "parentCode": "0120003",
        "code": "01200030001",
        "name": "자동차관리"
      },
      {
        "parentCode": "0120004",
        "code": "01200040001",
        "name": "자동차용품"
      },
      {
        "parentCode": "0120005",
        "code": "01200050001",
        "name": "주차장"
      },
      {
        "parentCode": "0120006",
        "code": "01200060001",
        "name": "중고차"
      },
      {
        "parentCode": "0120007",
        "code": "01200070001",
        "name": "폐차장"
      },
      {
        "parentCode": "0130001",
        "code": "01300010001",
        "name": "소프트웨어/솔루션"
      },
      {
        "parentCode": "0130002",
        "code": "01300020001",
        "name": "컴퓨터수리/보수"
      },
      {
        "parentCode": "0140001",
        "code": "01400010001",
        "name": "공구/산업용품"
      },
      {
        "parentCode": "0150001",
        "code": "01500010001",
        "name": "공공기관"
      },
      {
        "parentCode": "0150002",
        "code": "01500020001",
        "name": "일반단체"
      },
      {
        "parentCode": "0150003",
        "code": "01500030001",
        "name": "아파트/상가"
      },
      {
        "parentCode": "0150004",
        "code": "01500040001",
        "name": "정당/정치후보자"
      },
      {
        "parentCode": "0150005",
        "code": "01500050001",
        "name": "종교"
      },
      {
        "parentCode": "0160001",
        "code": "01600010001",
        "name": "판촉물/광고컨설팅/기타광고서비스"
      },
      {
        "parentCode": "0170001",
        "code": "01700010001",
        "name": "방송/신문"
      },
      {
        "parentCode": "0170002",
        "code": "01700020001",
        "name": "잡지/서적/출판사"
      },
      {
        "parentCode": "0180001",
        "code": "01800010001",
        "name": "웹호스팅/도메인/기타웹서비스"
      },
      {
        "parentCode": "0180002",
        "code": "01800020001",
        "name": "전용선/방송"
      },
      {
        "parentCode": "0180003",
        "code": "01800030001",
        "name": "통신서비스"
      },
      {
        "parentCode": "0180004",
        "code": "01800040001",
        "name": "포털서비스"
      },
      {
        "parentCode": "0190001",
        "code": "01900010001",
        "name": "결혼/소개팅"
      },
      {
        "parentCode": "0190002",
        "code": "01900020001",
        "name": "보안서비스"
      },
      {
        "parentCode": "0190003",
        "code": "01900030001",
        "name": "조경/청소/사진/심부름서비스"
      },
      {
        "parentCode": "0190003",
        "code": "01900030002",
        "name": "정수기/가전렌탈"
      },
      {
        "parentCode": "0190003",
        "code": "01900030003",
        "name": "보일러/냉방"
      },
      {
        "parentCode": "0190003",
        "code": "01900030004",
        "name": "정유/가스"
      },
      {
        "parentCode": "0190003",
        "code": "01900030005",
        "name": "배달/맛집정보"
      },
      {
        "parentCode": "0190003",
        "code": "01900030006",
        "name": "상조"
      },
      {
        "parentCode": "0190004",
        "code": "01900040001",
        "name": "취업/아르바이트"
      },
      {
        "parentCode": "0190005",
        "code": "01900050001",
        "name": "인력파견"
      },
      {
        "parentCode": "0190006",
        "code": "01900060001",
        "name": "기타일반서비스"
      },
      {
        "parentCode": "0200001",
        "code": "02000010001",
        "name": "건축/설비/자재"
      },
      {
        "parentCode": "0200002",
        "code": "02000020001",
        "name": "법률서비스"
      },
      {
        "parentCode": "0200003",
        "code": "02000030001",
        "name": "세무/회계/금융서비스"
      },
      {
        "parentCode": "0200004",
        "code": "02000040001",
        "name": "통/번역"
      },
      {
        "parentCode": "0200005",
        "code": "02000050001",
        "name": "기타전문서비스"
      },
      {
        "parentCode": "0210001",
        "code": "02100010001",
        "name": "맴버십/포인트"
      },
      {
        "parentCode": "0210002",
        "code": "02100020001",
        "name": "업무알림"
      }
    ]
  }
};
module.exports = categoryCode;